import {paginationMixin} from "@/domain/galleries/mixins";

const state = {
    photos: [],
    pagination: paginationMixin()
}

const getters = {
    photos: state => state.photos,
    pagination: state => state.pagination
}

const mutations = {
    setPhotos(state, {photos}) {
        if (state.photos.length > 0) {
            state.photos = state.photos.concat(photos)
        } else {
            state.photos = photos
        }
    },
    resetPagination(state) {
        state.photos = []
        state.pagination = paginationMixin()
    },
    setPagination(state, pagination) {
        state.pagination = pagination
    }
}

export const actions = (mediaService) => ({
    async fetchPhotos(context, {checkin_id, params}) {
        const response = await mediaService.getAllMedias(checkin_id, params)
        context.commit('setPhotos', {
            photos: response.results
        })
        context.commit('setPagination', response.pagination)
        return response.results
    },
    async checkNewAllPhotos(context, {checkin_id}) {
        // Fetch first page to compare total count
        const response = await mediaService.getAllMedias(checkin_id, {page: 1, page_size: 1})
        const currentPagination = context.getters.pagination
        
        const currentTotal = currentPagination.total || 0
        const newTotal = response.pagination.total || 0
        const newPhotosCount = newTotal - currentTotal
        
        return {
            hasNewPhotos: newPhotosCount > 0,
            totalNewPhotos: newPhotosCount,
            currentTotal: currentTotal,
            newTotal: newTotal,
            freshPagination: response.pagination
        }
    }
}
)

export default mediaService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(mediaService)
})